/**
 * 车辆信息详情，用来审核车辆
 */

import React, { Component } from 'react';
import { Modal, Button, Divider, Row, Col, Form, Input, Table, Tooltip, Tabs } from 'antd';

import ImageView from '../../ui/ImageView';
import Image from '../../ui/Image';
//引入样式
import './vehicleAuditStyle.css';
import messager from '../../ui/messager';
import http from '../../../axios/http';
//加载中遮罩
import Loading from '../../ui/Loading';
//车辆信息修改
import AuctionAuditEdit from './AuctionAuditEdit';
import { global_data } from '../../ui/auth';


const vehicleField = [{
    "text": "创建人",
    "field": "nickname",
}, {
    "text": "状态",
    "field": "statusStr",
}, {
    "text": "VIN",
    "field": "vin",
}, {
    "text": "车牌号",
    "field": "plateNo",
}, {
    "text": "初登日期",
    "field": "registerDate",
}, {
    "text": "品牌型号",
    "field": "brandModel",
}, {
    "text": "使用性质",
    "field": "usePropertyStr",
}, {
    "text": "车主姓名",
    "field": "owner",
}, {
    "text": "客户来源",
    "field": "clientSourceStr",
}, {
    "text": "车主住所",
    "field": "ownerAddress",
}];

const otherField = [{
    "text": "车辆名称",
    "field": "vehicleName",
}, {
    "text": "配置(加装)",
    "field": "detailHighlight",
}, {
    "text": "能源类型",
    "field": "fueltypeStr",
}, {
    "text": "变速箱类型",
    "field": "gearTypeStr",
}, {
    "text": "驱动方式",
    "field": "driveModeStr",
}, {
    "text": "表显里程(公里)",
    "field": "mileage",
}, {
    "text": "初次登记地",
    "field": "registerLocation",
}, {
    "text": "过户次数",
    "field": "transferTimes",
}, {
    "text": "钥匙数量",
    "field": "keyNum",
}, {
    "text": "证件",
    "field": "certificateStr",
}, {
    "text": "交强险有效期",
    "field": "mandatoryInsuranceDate",
}, {
    "text": "商业险有效期",
    "field": "commerciaInsuranceDate",
}, {
    "text": "出厂日期",
    "field": "productionDate",
}, {
    "text": "年检有效期",
    "field": "examinationDate",
}, {
    "text": "是否按揭",
    "field": "mortgageStr",
}, {
    "text": "回收配件",
    "field": "recycle",
    "colSpan": 5
}, {
    "text": "特殊情况说明",
    "field": "specialMark",
    "colSpan": 5
}, {
    "text": "备注",
    "field": "mark",
    "colSpan": 5
}];

//车辆照片信息
const vehicleImages = [{
    text: '左前',
    field: 'leftFrontImage'
}];

//配置信息
const configItem = [{
    "text": "遥控钥匙",
    "field": "remoteKey",
}, {
    "text": "真皮座椅",
    "field": "leatherSeats",
}, {
    "text": "无钥匙启动",
    "field": "keylessStart",
}, {
    "text": "换挡拨片",
    "field": "paddleShift",
}, {
    "text": "电动门窗",
    "field": "electricWindow",
}, {
    "text": "电动后视镜",
    "field": "electricRearviewMirror",
}, {
    "text": "天窗",
    "field": "skylight",
}, {
    "text": "备胎",
    "field": "spareTire",
}, {
    "text": "全景天窗",
    "field": "panoramicSkylight",
}, {
    "text": "多功能方向盘",
    "field": "multifunctionSteeringWheel",
}, {
    "text": "中控大屏",
    "field": "centralControlLargeScreen",
}, {
    "text": "主驾电动座椅",
    "field": "mainDrivingPowerSeat",
}, {
    "text": "副驾电动座椅",
    "field": "viceDrivingPowerSeat",
}, {
    "text": "座椅通风",
    "field": "seatVentilation",
}, {
    "text": "座椅加热",
    "field": "seatHeating",
}, {
    "text": "自动空调",
    "field": "automaticAirConditioner",
}, {
    "text": "电子手刹",
    "field": "electronicHandbrake",
}, {
    "text": "前雷达",
    "field": "frontRadar",
}, {
    "text": "后雷达",
    "field": "rearRadar",
}, {
    "text": "全息影像",
    "field": "hologram",
}, {
    "text": "倒车影像",
    "field": "reverseImage",
}];
//事故检测
const accidentItem = [{
    "text": "左前纵梁",
    "field": "leftFrontLongitudinalBeam",
}, {
    "text": "左前减震器座",
    "field": "leftFrontShockAbsorberSeat",
}, {
    "text": "左前翼子板内衬",
    "field": "leftFrontFenderLining",
}, {
    "text": "右前纵梁",
    "field": "rightFrontLongitudinalBeam",
}, {
    "text": "右前减震器座",
    "field": "rightFrontShockAbsorberSeat",
}, {
    "text": "右前翼子板内衬",
    "field": "rightFrontFenderLining",
}, {
    "text": "防火墙",
    "field": "firewall",
}, {
    "text": "水箱框架",
    "field": "waterTankFrame",
}, {
    "text": "车架号",
    "field": "frameNumber",
}, {
    "text": "左A柱",
    "field": "leftAPillar",
}, {
    "text": "左B柱",
    "field": "leftBPillar",
}, {
    "text": "左C柱",
    "field": "leftCPillar",
}, {
    "text": "左D柱",
    "field": "leftDPillar",
}, {
    "text": "左后纵梁",
    "field": "leftRearLongitudinalBeam",
}, {
    "text": "后围板",
    "field": "backboard",
}, {
    "text": "右A柱",
    "field": "rightAPillar",
}, {
    "text": "右B柱",
    "field": "rightBPillar",
}, {
    "text": "右C柱",
    "field": "rightCPillar",
}, {
    "text": "右D柱",
    "field": "rightDPillar",
}, {
    "text": "车顶",
    "field": "roof",
}, {
    "text": "火烧检查",
    "field": "fireCheck",
}, {
    "text": "水泡检查",
    "field": "blisterInspection",
}];
//动力系统检测
const engineItem = [{
    "text": "发动机",
    "field": "engine",
}, {
    "text": "变速箱",
    "field": "gearbox",
}, {
    "text": "转向机构",
    "field": "steeringMechanism",
}, {
    "text": "减震器",
    "field": "shockAbsorber",
}, {
    "text": "尾气",
    "field": "exhaust",
}];
//漆面检测
const paintItem = [{
    "text": "左前翼子板",
    "field": "leftFrontFender",
}, {
    "text": "左前车门",
    "field": "frontLeftDoor",
}, {
    "text": "左前A柱外侧",
    "field": "leftFrontAPillarOutside",
}, {
    "text": "左车顶边梁外侧",
    "field": "leftSideRoofBeamOutside",
}, {
    "text": "左后车门",
    "field": "rearLeftDoor",
}, {
    "text": "左C柱外侧",
    "field": "reftCPillarOutside",
}, {
    "text": "左后翼子板",
    "field": "leftRearFender",
}, {
    "text": "后备箱盖",
    "field": "trunkLid",
}, {
    "text": "右后翼子板",
    "field": "rightRearFender",
}, {
    "text": "右c柱外侧",
    "field": "rightCPillarOutside",
}, {
    "text": "右后车门",
    "field": "rearRightDoor",
}, {
    "text": "右车顶边梁外侧",
    "field": "outsideOfRightRoofSideBeam",
}, {
    "text": "右A柱外侧",
    "field": "rightAPillarOutside",
}, {
    "text": "右前车门",
    "field": "frontRightDoor",
}, {
    "text": "右前翼子板",
    "field": "rightFrontFender",
}, {
    "text": "发动机盖",
    "field": "engineCover",
}, {
    "text": "前保险杠",
    "field": "frontBumper",
}, {
    "text": "后保险杠",
    "field": "rearBumper",
}];

class AuctionAuditDetail extends Component {

    state = {
        activeKey: 'base',
        image: null,
        previewVisible: false,
        previewImage: null,
        loadingVisible: false,

        failVisible: false, //显示退回输入框

        visible: false, //编辑框显示
    }

    columns = [
        {
            title: '操作时间',
            dataIndex: 'time',
            width: '20%',
        }, {
            title: '操作人',
            dataIndex: 'name',
            width: '10%',
        }, {
            title: '状态',
            dataIndex: 'status',
            width: '10%',
            render: (text, record, index) => {
                let status = { "DRAFT": "草稿", "UNVERIFYING": "提交", "VERIFYED": "已审核", "VERIFY_FAIL": "审核不通过", "WILL_AUCTION": "即将竞价" };
                return status[text];
            }
        }, {
            title: '说明',
            dataIndex: 'info',
            width: '20%',
            render: (text, record, index) => (
                <Tooltip title={text}>
                    <span>{text}</span>
                </Tooltip>
            )
        }];

    createDetailTable = (data) => {
        const { editData } = this.props;
        let dom = [];
        let tdNum = 3;
        for (let i = 0; i < data.length; i += tdNum) {
            let td = [];
            for (let j = 0; j < tdNum && (i + j) < data.length; j++) {
                let text = (<td key={"td" + i + j}>{data[i + j]["text"] + "："}</td>);
                let colSpan = 1;
                if ((i + j) === (data.length - 1)) {
                    colSpan = (tdNum - j) * 2 - 1;
                }
                if (data[i + j]["colSpan"] != null) {
                    colSpan = data[i + j]["colSpan"];
                }
                let field = (<td key={"td" + i + j + 1} colSpan={colSpan}>{editData[data[i + j]["field"]]}</td>);
                td.push(text);
                td.push(field);
                if (data[i + j]["colSpan"] != null) {
                    let d = (data[i + j]["colSpan"] - 1) / 2;
                    i -= d;
                    break;
                }
            }
            let tr = (<tr key={"tr" + i}>{td}</tr>);
            dom.push(tr);
        }
        let table = (
            <table className="vehicle-detail-table">
                <tbody>
                    {dom}
                </tbody>
            </table>
        );
        return table;
    }

    // 图片列表
    createImageDom = (field) => {
        let dom = [];
        const { editData } = this.props;
        for (let i = 0; i < field.length; i += 1) {
            let path = editData != null && editData[field[i]["field"] + "Thumb"] ? "data:image/jpeg;base64," + editData[field[i]["field"] + "Thumb"] : "";
            let imgurl = editData && editData[field[i]["field"]] ? editData[field[i]["field"]] : "";
            let img = this.createImageCol(path, imgurl, field[i].text, i);
            dom.push(img);
        }
        return dom;
    }

    createImageList = (imageKey) => {
        let dom = [];
        const { editData } = this.props;
        let vehicleImages = editData[imageKey];
        let thumbnails = editData[imageKey + "Thumb"];
        if (vehicleImages == null || vehicleImages.length === 0) return;
        if (thumbnails != null && thumbnails.length > 0) {
            thumbnails.forEach((item, index) => {
                let image = "data:image/jpeg;base64," + item
                let img = this.createImageCol(image, vehicleImages[index], null, index);
                dom.push(img);
            })
        }
        return dom;
    }

    createImageCol = (image, url, text, key) => {
        let img = (
            <Col span={3} key={key} style={{ margin: '5px 0' }}>
                <Image
                    onlyView={true}
                    file={image}
                    text={text}
                    url={url}
                />
            </Col>
        );
        return img;
    }

    createImageTextCol = (image, url, text, key) => {
        let img = (
            <Col span={3} key={key} style={{ margin: '5px 0' }}>
                <Image
                    onlyView={true}
                    file={image}
                    text={text}
                    url={url}
                />
                <div className="image-desc">{text}</div>
            </Col>
        );
        return img;
    }

    createDetectInfoDom = (data) => {
        const { editData } = this.props;
        let detectInfo = editData["detectionInfo"];
        let dom = [];
        let tdNum = 5;
        for (let i = 0; i < data.length; i += tdNum) {
            let td = [];
            for (let j = 0; j < tdNum && (i + j) < data.length; j++) {
                let text = (<td key={"td" + i + j}>{data[i + j]["text"] + "："}</td>);
                let value = "";
                if (i + j >= data.length) {
                    break;
                }
                if (detectInfo !== null && detectInfo !== undefined) {
                    value = detectInfo[data[i + j]["field"]];
                    if (value === 1) {
                        value = "有";
                    }
                    else {
                        value = "无";
                    }
                }
                let field = (<td className="narrow" key={"td" + i + j + 1} >{value}</td>);
                td.push(text);
                td.push(field);
            }
            let tr = (<tr key={"tr" + i}>{td}</tr>);
            dom.push(tr);
        }
        let table = (
            <table className="vehicle-detect-table">
                <tbody>
                    {dom}
                </tbody>
            </table>
        );
        return table;
    };

    createDetectDetailDom = (data, type) => {
        const { editData } = this.props;
        let detectionDetail = editData["detectionDetail"];
        let detectionDetailDesc = editData["detectionDetailDesc"];
        let dom = [];
        let tdNum = 2;
        for (let i = 0; i < data.length; i += tdNum) {
            let td = [];
            for (let j = 0; j < tdNum && (i + j) < data.length; j++) {
                let text = (<td key={"td" + i + j}>{data[i + j]["text"] + "："}</td>);
                let value = "";
                let desc = "";
                let className = "detect-ok"
                if (i + j >= data.length) {
                    break;
                }
                if (detectionDetail !== null && detectionDetail !== undefined) {
                    value = detectionDetail[data[i + j]["field"]];
                    if (value === "1") {
                        value = "正常";
                    }
                    else {
                        value = "异常";
                        className = "detect-warn"
                        desc = detectionDetailDesc[data[i + j]["field"]];
                        if (type === "paint") {
                            desc = desc.replace("0", "漆面修复");
                            desc = desc.replace("1", "腻子修复");
                            desc = desc.replace("2", "疑似更换");
                            desc = desc.replace("3", "异常未修复");
                        }
                    }
                }
                let valueTd = (<td className={className} key={"td" + i + j + 1}>{value}</td>);
                let descTd = (<td className={className} key={"td" + i + j + 2}>{desc}</td>);
                td.push(text);
                td.push(valueTd);
                td.push(descTd);
            }
            let tr = (<tr key={"tr" + i}>{td}</tr>);
            dom.push(tr);
        }
        let table = (
            <table className="vehicle-detect-detail-table">
                <tbody>
                    {dom}
                </tbody>
            </table>
        );
        return table;
    };

    //创建检测异常图片
    createDetectImgsDom = () => {
        let dom = [];
        const { editData } = this.props;
        let images = editData["detectionDetailImgs"];
        let thumbnails = editData["detectionDetailThumb"];
        if (images !== null && images !== undefined) {
            if (thumbnails !== null && thumbnails !== undefined) {
                for (let key in images) {
                    if (images[key] !== null && images[key] !== undefined) {
                        accidentItem.forEach((item, index) => {
                            if (key === item.field) {
                                let image = "data:image/jpeg;base64," + thumbnails[key];
                                let img = this.createImageCol(image, images[key], item.text, key);
                                dom.push(img);
                            }
                        });
                        engineItem.forEach((item, index) => {
                            if (key === item.field) {
                                let image = "data:image/jpeg;base64," + thumbnails[key];
                                let img = this.createImageCol(image, images[key], item.text, key);
                                dom.push(img);
                            }
                        });
                    }

                }
            }
        }
        return dom;
    }
    //创建检测异常图片
    createDefectImgsDom = (field) => {
        let dom = [];
        const { editData } = this.props;
        let detectionInfo = editData["detectionInfo"];
        if (detectionInfo === null || detectionInfo === undefined) {
            return;
        }
        let images = detectionInfo[field];
        let thumbnails = editData[field + "Thumb"];
        if (images !== null && images !== undefined && images.length > 0) {
            if (thumbnails !== null && thumbnails !== undefined && thumbnails.length > 0) {
                thumbnails.forEach((item, index) => {
                    let image = "data:image/jpeg;base64," + item;
                    let img = this.createImageTextCol(image, images[index].img, images[index].desc, index);
                    dom.push(img);
                });
            }
        }
        return dom;
    }

    createSummaryDom = () => {
        const { editData } = this.props;
        let detectInfo = editData["detectionInfo"];
        let dom = [];
        let summary = "";
        if (detectInfo !== null && detectInfo !== undefined) {
            summary = detectInfo.summary;
            if (summary === null || summary === undefined) {
                summary = "无";
            }
        }
        dom.push(<div key={"summary"} className="detectDesc-content">{summary}</div>);
        return dom;
    }

    //审核车辆
    auditVehicle = (type) => {
        let text = "审核通过";
        if (type === "WILL_AUCTION") {
            //通过审核，通过审核之前要校验是否已经选择了车辆来源
            let clientSource = this.props.editData.clientSource;
            if(clientSource == null || clientSource === ""){
                messager.alert("请先选择车辆来源，再通过车辆审核！");
                return ;
            }
        } else if (type === "VERIFY_FAIL") {
            //不通过审核
            this.setState({ failVisible: true })
            return;
        } else if (type === "EDIT") {
            this.setState({ visible: true });
            return;
        }
        messager.confirm("是否" + text + "该车辆？", () => {
            const { editData, successCallback, queryData, onCancel } = this.props;
            this.setState({ loadingVisible: true });
            http.post({
                url: "/auction/web/audit/verify/success",
                data: { id: editData.id },
                success: (res) => {
                    this.setState({ loadingVisible: false });
                    onCancel();
                    messager.notify(text + "成功！");
                    queryData.notChangePage = true;
                    successCallback(queryData);
                },
                error: (res) => {
                    this.setState({ loadingVisible: false });
                    messager.alert(res, "异常", "error");
                }
            });
        });
    }

    hiddenModalFail = () => {
        this.setState({ failVisible: false });
    }

    doFailSuccess = () => {
        const { successCallback, queryData, onCancel } = this.props;
        onCancel();
        this.hiddenModalFail();
        queryData.notChangePage = true;
        successCallback(queryData);
    }

    render() {
        const { visible, onCancel, editData } = this.props;
        let operationRecord = editData.operationRecords;
        return (
            <Modal
                width={1200}
                visible={visible}
                title="车辆审核详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                zIndex={1000}
                footer={[
                    global_data.authCode.includes("AUCTION_SESSION_EDIT_ADMIN")||editData["status"] === "UNVERIFYING" ? 
                    <Button key="EDIT" type="primary" onClick={this.auditVehicle.bind(this, "EDIT")}>修改</Button> 
                    : "",
                    editData["status"] === "UNVERIFYING" ? <Button key="WILL_AUCTION" type="primary" onClick={this.auditVehicle.bind(this, "WILL_AUCTION")}>通过</Button> : "",
                    editData["status"] === "UNVERIFYING" ? <Button key="VERIFY_FAIL" type="danger" onClick={this.auditVehicle.bind(this, "VERIFY_FAIL")}>退回</Button> : "",
                    // editData["status"] === "WILL_AUCTION" ? <Button key="PUTOFF" type="danger" onClick={this.auditVehicle.bind(this, "PUTOFF")}>下架</Button> : "",
                    <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                ]}
            >
                <div>
                    <Tabs tabPosition='left' activeKey={this.state.activeKey}
                        onChange={(activeKey) => {
                            this.setState({ activeKey: activeKey });
                        }}
                    >
                        <Tabs.TabPane tab="基本信息" key="base">
                            <Divider orientation="left">基本信息</Divider>
                            {this.createDetailTable(vehicleField)}
                            <Divider orientation="left">其他信息</Divider>
                            {this.createDetailTable(otherField)}
                            <Divider orientation="left">手续照片</Divider>
                            <Row>{this.createImageList("certificateImages", "certificateImagesThumb")}</Row>
                            <Divider orientation="left">车辆照片</Divider>
                            <Row>
                                {this.createImageDom(vehicleImages)}
                            </Row>
                            <Divider orientation="left">基本照片</Divider>
                            <Row>{this.createImageList("baseImages", "baseImagesThumb")}</Row>
                            <Divider orientation="left">瑕疵照片</Divider>
                            <Row>{this.createImageList("flawImages", "flawImagesThumb")}</Row>                
                            <Divider orientation="left">检测报告</Divider>
                            <Row>{this.createImageList("detectionImages", "detectionImagesThumb")}</Row>


                            <Divider orientation="left">其他照片</Divider>
                            <Row>{this.createImageList("vehicleImages", "vehicleImagesThumb")}</Row>
                            <Divider orientation="left">车辆审核记录</Divider>
                            <Row>
                                <Table rowKey="time" columns={this.columns} dataSource={operationRecord} pagination={{ pageSize: 5 }} />
                            </Row>
                        </Tabs.TabPane>
                        {editData["detectionInfo"] ? <Tabs.TabPane tab="检测信息" key="detect">
                            <Divider orientation="left">配置信息</Divider>
                            {this.createDetectInfoDom(configItem)}
                            <Divider orientation="left">事故检测</Divider>
                            {this.createDetectDetailDom(accidentItem)}
                            <Divider orientation="left">动力系统检测</Divider>
                            {this.createDetectDetailDom(engineItem)}
                            <Divider orientation="left">漆面检测</Divider>
                            {this.createDetectDetailDom(paintItem, "paint")}
                            <Divider orientation="left">评估师总结</Divider>
                            {this.createSummaryDom()}
                            <Divider orientation="left">检测异常图片</Divider>
                            {this.createDetectImgsDom()}
                            <Divider orientation="left">车辆外观缺陷</Divider>
                            {this.createDefectImgsDom("exteriorDefect")}
                            <Divider orientation="left">车辆内饰缺陷</Divider>
                            {this.createDefectImgsDom("interiorDefect")}
                            <Divider orientation="left">车辆其他缺陷</Divider>
                            {this.createDefectImgsDom("otherDefect")}
                        </Tabs.TabPane>: ""}
                    </Tabs>
                </div>
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据处理中..."
                />
                <AuctionAuditFail
                    visible={this.state.failVisible}
                    onCancel={this.hiddenModalFail.bind(this)}
                    editData={editData}
                    successCallback={this.doFailSuccess}
                />
                <AuctionAuditEdit
                    visible={this.state.visible}
                    editData={editData}
                    onCancel={() => { this.setState({ visible: false }) }}
                    successCallback={() => { this.props.successCallback(this.props.queryData) }}
                />
            </Modal>
        );
    }
}


class AuctionAuditFailForm extends Component {


    failVehilce = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["id"] = this.props.editData.id;
            http.post({
                url: "/auction/web/audit/verify/fail",
                data: values,
                success: (res) => {
                    this.props.onCancel();
                    this.props.successCallback();
                    messager.notify("退回成功！");
                }
            });
        });
    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="退回车辆"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.failVehilce}
                zIndex={1001}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                    <Form.Item label="退回理由：">
                        {getFieldDecorator('msg', {
                            rules: [
                                { required: true, message: '退回理由不能为空!' },
                                { max: 256, message: '最多只能输入256个字符！' }],
                        })(
                            <Input.TextArea />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}


const AuctionAuditFail = Form.create()(AuctionAuditFailForm);


export default AuctionAuditDetail;